import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

const Loading = () => {
  return (
    <SpinWrapper>
      <Spin size="large" />
    </SpinWrapper>
  );
};

const SpinWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Loading;
